import { render } from "./OurValues.vue?vue&type=template&id=3e76a002&scoped=true"
import script from "./OurValues.vue?vue&type=script&lang=js"
export * from "./OurValues.vue?vue&type=script&lang=js"

import "./OurValues.vue?vue&type=style&index=0&id=3e76a002&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e76a002"]])

export default __exports__